// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZIUbB","importantInfo":"styles_importantInfo__9bj28"};